<!--
* @Description:审核不通过弹窗
* @Date: 2024-12-03 15:55:01
-->
<template>
  <div class="">
    <BaseTextContent>
      <BaseForm
        :label-position="labelPosition"
        label-width="200px"
        :model="formData"
        ref="ruleFormRef"
        :disabled="disabled"
      >
        <BaseFormItem :rules="rulesFrom" :label="label" prop="data">
          <BaseInput
            style="width: 100%"
            v-model="formData.data"
            :maxlength="maxlength"
            show-word-limit
            :type="type"
            :rows="rows"
            :placeholder="placeholder"
          ></BaseInput>
        </BaseFormItem>
      </BaseForm>
    </BaseTextContent>
  </div>
</template>

<script lang="ts" setup>
import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseFormRef,
  BaseTextContent
} from 'xrk-components';
import { reactive, ref, computed, watch } from 'vue';
const ruleFormRef = ref<BaseFormRef>();
const props = withDefaults(
  defineProps<{
    placeholder: string;
    label: string;
    maxlength: string | number;
    ruleValidator: (
      rule: any,
      value: any,
      callback: (error?: string | Error) => void
    ) => void;
    type: 'number' | 'textarea' | 'text' | 'password' | 'tel';
    disabled: boolean;
    rows: number;
    defaultValue: number | string;
    labelPosition: 'left' | 'right' | 'top';
  }>(),
  {
    labelPosition: 'top',
    disabled: false,
    rows: 7
  }
);

let formData = reactive<{ data: any }>({
  data: props.defaultValue ? props.defaultValue : ''
});
watch(
  () => formData.data,
  val => {
    if (val == null) {
      formData.data = '';
    }
  }
);
const rulesFrom = computed(() => {
  return [
    {
      required: true,
      validator: props.ruleValidator as (
        rule: any,
        value: any,
        callback: (error?: string | Error) => void
      ) => void,
      trigger: 'change'
    }
  ];
});

defineExpose({
  getFormData: () => {
    return new Promise((reslve, reject) => {
      ruleFormRef.value.validate(valid => {
        if (valid) {
          reslve(formData);
        } else {
          reject('error submit!');
        }
      });
    });
  }
});
</script>

<style lang="scss" scoped></style>
